export function jsText(parentSelector) {
    parentSelector = parentSelector || '';
    $('[data-js-text]', parentSelector).each(function (i, e) {
        let $self = $(e);
        $self.text($self.data('js-text'));
    });
}